import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';

import type { User } from '@/@types/global';
import { selectedUnifiedIdAtom } from '@/app/appHeader/imageViewerMenu/atoms';
import { makeAPIRequestReactQuery } from '@/react-query/api';
import { endpoints } from '@/react-query/endpoints';
import { usePreferences } from '@/react-query/usePreferences';

import type { PerioChartResponse } from '../common-components/composed/PerioChart/types';

export const useGetPerioChart = () => {
  const { data: preferences } = usePreferences();
  const user = useSelector(
    (state: { login?: { user?: User } }) => state.login?.user,
  );
  const primaryPracticeId = user?.primaryPracticeId;
  const primaryOrganizationId = user?.primaryOrganizationId;
  const unifiedAppointmentId = useAtomValue(selectedUnifiedIdAtom);

  return useQuery({
    queryKey: [
      endpoints.perioChart,
      unifiedAppointmentId,
      primaryOrganizationId,
      primaryPracticeId,
    ],
    queryFn: async () => {
      return await makeAPIRequestReactQuery<PerioChartResponse>(
        `/${endpoints.perioChart}`,
        undefined,
        'GET',
        {
          params: { unifiedAppointmentId },
          headers: { Org: primaryOrganizationId, Practice: primaryPracticeId },
        },
      );
    },
    enabled:
      !!preferences?.enablePerioChartInClinicalAssist &&
      !!unifiedAppointmentId &&
      !!primaryPracticeId &&
      !!primaryOrganizationId,
  });
};
